import { motion } from "framer-motion";
import { Check, Droplets, Clock } from "lucide-react";

const statusColor = {
  done: "bg-emerald-600 border-emerald-600 text-white",
  active: "bg-amber-500 border-amber-500 text-white",
  upcoming: "bg-white border-stone-300 text-stone-400",
};

export const Timeline = ({ milestones, onSelect }) => {
  return (
    <div data-testid="milestone-timeline" className="timeline-scroll overflow-x-auto pb-4">
      <div className="flex items-stretch gap-0 min-w-max px-1">
        {milestones.map((m, i) => (
          <div key={m.key} className="flex items-center">
            <motion.button
              data-testid={`milestone-node-${m.key}`}
              onClick={() => onSelect && onSelect(m)}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.05 }}
              className="group flex flex-col items-center w-44 text-center px-2"
            >
              <div className={`w-11 h-11 rounded-full border-2 flex items-center justify-center transition-transform group-hover:scale-110 ${statusColor[m.status]}`}>
                {m.status === "done" ? <Check className="w-5 h-5" /> : m.type === "watering_series" ? <Droplets className="w-5 h-5" /> : <Clock className="w-5 h-5" />}
              </div>
              <span className="mt-3 text-[10px] uppercase tracking-[0.15em] text-stone-400">{m.phase}</span>
              <span className="mt-1 text-sm font-semibold text-emerald-950 leading-tight">{m.title}</span>
              <span className="mt-1 font-mono-ag text-[11px] text-stone-500">{m.due_date}</span>
            </motion.button>
            {i < milestones.length - 1 && (
              <div className={`h-[2px] w-8 ${m.status === "done" ? "bg-emerald-500" : "bg-stone-200"}`} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
